import './article.css';
import React from 'react';
import ArticleCard from '../cards/articleCard.js';

function ArticleIterableCards() {
  const articleDocs = [{
    alt: "MEDIUM",
    articleLink: "https://danyson.medium.com/",
    description: "Collection of my Technical Articles in Medium",
    imageUrl: "https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png",
    title: "MEDIUM Articles"
  },
  {
    alt: "IEEE",
    articleLink: "https://ieeexplore.ieee.org/document/9099887",
    description: "BALANCE: Link Flooding Attack Detection and Mitigation via Hybrid-SDN",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Ieee_blue.jpg/800px-Ieee_blue.jpg",
    title: "IEEE Publication"
  },
  {
    alt: "DEV",
    articleLink: "https://dev.to/danyson",
    description: "My Official Engineering Blog",
    imageUrl: "https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png",
    title: "Dev.to Articles"
  },
  {
    alt: "LINKEDIN",
    articleLink: "https://www.linkedin.com/in/danyson/recent-activity/all/",
    description: "Collection of my LinkedIn posts about our IT services",
    imageUrl: "https://brand.linkedin.com/etc.clientlibs/settings/wcm/designs/gandalf/clientlibs/resources/images/og-social-share-image.jpg",
    title: "LinkedIn Posts"
  },
  {
    alt: "CASE_STUDY",
    articleLink: "https://case-study-danyson.blogspot.com/",
    description: "Case Study about our Projects",
    imageUrl: "https://png.pngtree.com/thumb_back/fh260/background/20220122/pngtree-case-study-learn-letter-knowledge-photo-image_7987832.jpg",
    title: "Case Study"
  }]
  return (
    <div>
      <div className="Article">
        <body className="Article-body">
          {
            articleDocs && articleDocs.map(value => {
              return (
                <div className="Article-card">
                  <ArticleCard
                    title={value.title}
                    description={value.description}
                    imageUrl={value.imageUrl}
                    link={value.articleLink}
                    alt={value.alt} />
                </div>
              )
            }
            )
          }
          <div className="Article-trademarks">
            <p > IEEE&copy; &nbsp; DEV&copy; &nbsp; MEDIUM&copy; &nbsp; LINKEDIN&copy;
              &nbsp;logos are registered trademarks of those Organizations &nbsp;</p>
            <p > &copy; Copyright 2024 All rights reserved</p>
          </div>
        </body>
      </div>
    </div>
  );

}

export default ArticleIterableCards;

